import { Injectable, inject } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "../auth/services/auth.service";
import { catchError } from "rxjs/operators";
import { ALERT_HISTORY_AUTH } from "../../features/alerts/services/alert-history-session.service";

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  private readonly auth = inject(AuthService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error) => {
        // Alert History 401s are handled by the AuthorizationInterceptor,
        // which redirects to the logout_url instead (TWX-536)
        if (error.status === 401 && !req.context.get(ALERT_HISTORY_AUTH)) {
          this.auth.clearSession();
        }
        throw error;
      }),
    );
  }
}
